import { FC } from "react";
import { models } from "types/api/viewModels";
import {
	ArrowContainer,
	ArrowIcon,
	FieldDetails,
	FieldName,
	FieldValue,
	JobName,
	OrderCard,
	OrderDetails,
	TruckFlyoutOrderCardChips,
	TruckOrderType
} from "./TruckDetailsFlyoutOrderCard.styles";
import { convertToTitleCase } from "utils/string";
import { useNavigate } from "react-router";
import {
	AccessoryCountText,
	CabinetCountText,
	CubeCountText,
	DesignerNumberText,
	PONumberText,
	ReplacmentConfirmationOrderNumber,
	UnavailableDataPlaceholderText
} from "constants/text";
import { OrderSummaryCardChip } from "components/OrderSummaryCard/OrderSummaryCard.styles.ts";

interface TruckDetailsFlyoutOrderCardProps {
	order: models["OrderViewModel"];
}

const TruckDetailsFlyoutOrderCard: FC<TruckDetailsFlyoutOrderCardProps> = ({ order }) => {
	const navigateToDetails = useNavigate();
	return (
		<OrderCard onClick={() => navigateToDetails(`/details/${order.orderId}`)}>
			<OrderDetails>
				<FieldDetails>
					<JobName data-testid="truckDetails-orderJobName">
						{order.jobName ?? order.poNumber ?? UnavailableDataPlaceholderText}
					</JobName>
					<TruckOrderType
						data-testid="truckDetails-orderType"
						label={convertToTitleCase(order.orderType)}
					/>
				</FieldDetails>
				<FieldDetails>
					<FieldName>{ReplacmentConfirmationOrderNumber}</FieldName>
					<FieldValue data-testid="truckDetails-orderNumber">{order.orderNumber}</FieldValue>
				</FieldDetails>
				<FieldDetails>
					<FieldName>{PONumberText}</FieldName>
					<FieldValue data-testid="truckDetails-orderPoNumber">{order.poNumber}</FieldValue>
				</FieldDetails>
				<FieldDetails>
					<FieldName>{DesignerNumberText}</FieldName>
					<FieldValue data-testid="truckDetails-orderDesignerNumber">
						{order.designer?.designerNumber ?? UnavailableDataPlaceholderText}
					</FieldValue>
				</FieldDetails>
				<FieldDetails data-testid="truck-flyout-order-cabCount-field">
					<FieldName>{CabinetCountText}</FieldName>
					<FieldValue data-testid="truckDetails-orderCabCount">
						{order.counts?.cabinetCount ?? UnavailableDataPlaceholderText}
					</FieldValue>
				</FieldDetails>
				<FieldDetails data-testid="truck-flyout-order-accCount-field">
					<FieldName>{AccessoryCountText}</FieldName>
					<FieldValue data-testid="truckDetails-orderAccessoryCount">
						{order.counts?.accessoryCount ?? UnavailableDataPlaceholderText}
					</FieldValue>
				</FieldDetails>
				<FieldDetails data-testid="truck-flyout-order-cubeCount-field">
					<FieldName>{CubeCountText}</FieldName>
					<FieldValue data-testid="truckDetails-orderCubeCount">
						{order.counts?.cubeCount ?? UnavailableDataPlaceholderText}
					</FieldValue>
				</FieldDetails>
				<TruckFlyoutOrderCardChips>
					{order?.status && (
						<OrderSummaryCardChip
							label={convertToTitleCase(order.status)}
							chipTitle={order.status}
						/>
					)}
					{order?.statusReason && (
						<OrderSummaryCardChip
							label={convertToTitleCase(order.statusReason)}
							chipTitle={order.statusReason}
						/>
					)}
				</TruckFlyoutOrderCardChips>
			</OrderDetails>
			<ArrowContainer>
				<ArrowIcon style={{ cursor: "pointer" }} />
			</ArrowContainer>
		</OrderCard>
	);
};

export default TruckDetailsFlyoutOrderCard;
